'use client';
import { useCallback, useEffect, useState } from 'react';

import { detectIfBannerCtaClicked } from './retention-popup-url-parser';

export const useHashListener = (onClose: () => void, isReady: boolean) => {
	const [needsToBeClosed, setNeedsToBeClosed] = useState(false);

	const onhashchange = useCallback(() => {
		if (detectIfBannerCtaClicked()) {
			setNeedsToBeClosed(true);
		}
	}, []);

	useEffect(() => {
		onhashchange();
		window.addEventListener('hashchange', onhashchange);
		return () => {
			window.removeEventListener('hashchange', onhashchange);
		};
	}, [onhashchange]);

	useEffect(() => {
		if (needsToBeClosed && isReady) {
			onClose();
		}
	}, [onClose, needsToBeClosed, isReady]);
};
